<template>
  <v-app>
    <hbt-navbar :endtime="endtime" />
    <router-view class="view" :endtime="endtime" ></router-view>
  </v-app>
</template>

<script>
import HbtNavbar from './components/Navbar';

export default {
  name: 'App',

  components: {
    HbtNavbar,
  },

  data: () => ({
    endtime: 'Mar 22, 2020 16:00:00',
  }),
};
</script>
